import { initializeForecast } from "./configure_forecast.js";
import { initializeSalesReportManager } from "./configure_goals.js";
import { initializeSalesReportMtd } from "./configure_mtd.js";
import { showDashboard } from "./dashboard.js";
import { app } from "./session.js";

(window as any).showDashboard = showDashboard;
(window as any).showGoals = initializeSalesReportManager;
(window as any).showUpdateMTDForm = initializeSalesReportMtd;
(window as any).showUpdateForecastForm = initializeForecast;

app.onInit().then(async () => {
  // Update UI based on whether the user is logged in and what permissions they have
  const updateUI = async () => {
    const isAuthenticated = await app.AUTH0.isAuthenticated();
    if (isAuthenticated) {
      document.getElementById('login')?.classList.add('hidden');
      document.getElementById('app')?.classList.remove('hidden');

      {
        const user = await app.AUTH0.getUser();
        const userNameField = document.getElementById('user-name')
        if (user && userNameField) {
          userNameField.textContent = `Logged in as ${user.name}`;
        }
      }

      // Example: assume permissions are attached to the user profile under a custom namespace.
      // (Configure your Auth0 rules or API scopes so that the permissions array is included.)
      const { permissions } = await app.TOKEN;

      let pageLoaded = false;

      // Show menu items based on permissions:
      if (permissions.includes('salereport:dashboard') || permissions.includes('salereport:manager')) {
        document.getElementById('menu-dashboard')?.classList.remove('hidden');
        showDashboard();
        pageLoaded = true;
      }
      if (permissions.includes('salereport:manager')) {
        document.getElementById('menu-goals')?.classList.remove('hidden');
      }
      if (permissions.includes('salereport:operation')) {
        document.getElementById('menu-update-mtd')?.classList.remove('hidden');
        if (!pageLoaded) {
          initializeSalesReportMtd();
          pageLoaded = true;
        }
      }
      if (permissions.includes('salereport:team_member')) {
        document.getElementById('menu-update-forecast')?.classList.remove('hidden');
        if (!pageLoaded) {
          initializeForecast();
          pageLoaded = true;
        }
      }
    } else {
      document.getElementById('login')?.classList.remove('hidden');
      document.getElementById('app')?.classList.add('hidden');
    }
  };

  // Login and logout functions
  const login = async () => {
    await app.AUTH0.loginWithRedirect();
  };

  const logout = () => {
    //const origin = window.location.origin;
    app.AUTH0.logout();
  };

  document.getElementById('btn-login')?.addEventListener('click', login);
  document.getElementById('btn-logout')?.addEventListener('click', logout);

  const isLoginReturn = window.location.search.includes("code=") && window.location.search.includes("state=");
  if (isLoginReturn) {
    await app.AUTH0.handleRedirectCallback();
    window.history.replaceState({}, document.title, "/");
    // Must reinitialize to get new token details.
    await app.initialize();
    updateUI();
  } else if (!await app.AUTH0.isAuthenticated()) {
    await app.AUTH0.loginWithRedirect();
  }
  else {
    updateUI();
  }
});


